export default __webpack_public_path__ + "static/promo-cutout-c4ea91a8332c28de868f6db7f121b799.png";